import { createCachedSelector } from "re-reselect";

import { getLegCitiesAndLocationsHelper } from "../../../../helpers/udm/get-leg-cities-and-locations";
import { getTripsCities, getTripsLocations } from "../state-accessors";
import { getSearchedLegSegments } from "../trips/get-segments";

export const getLegCitiesAndLocations = createCachedSelector(
  [getTripsCities, getTripsLocations, getSearchedLegSegments],
  getLegCitiesAndLocationsHelper
)((_state, trip_id) => trip_id);
